import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  name: {
    fontSize: "1.313rem",
    fontWeight: "bold",
  },
  activeDate: {
    color: "#808080",
  },
  clientSelect: {
    width: "100%",
  },
}))

export default styles
